import type { InquiryItem } from '@/types/api';
import useCopy from '@/hooks/useCopy';
import CopyIcon from '@/assets/icons/OrderDetails/eva_copy-outline.svg?react';
import { Button } from '@/components/atoms/NewPcButton';

import GenerateAnswer from './GenerateAnswer';
import SubmitButton from './SubmitButton';
import SelectTemplate from './SelectTemplate';

export interface AnswerControllerProps {
  comment: string;
  setComment?: (comment: string) => void; // Optional for AutoResizeTextarea
  inquiry: InquiryItem;
  handleRegister: () => void; // Optional for SubmitButton
  isLoading?: boolean; // Optional for SubmitButton
  recommendationCommentList?: string[]; // Optional for GenerateAIAnswer
}

const AnswerController = ({
  comment,
  setComment,
  inquiry,
  handleRegister,
  isLoading,
}: AnswerControllerProps) => {
  const { copyToClipboard } = useCopy({
    toastMessage: '복사가 완료되었습니다',
  });

  return (
    <div className="flex min-w-0 items-start justify-between gap-3">
      <div className="scrollbar flex min-w-0 flex-1 items-start gap-[8px] overflow-x-auto pb-1">
        <div className="shrink-0">
          <GenerateAnswer inquiry={inquiry} setComment={setComment} />
        </div>
        <div className="shrink-0">
          <SelectTemplate setComment={setComment} />
        </div>
        <Button
          onClick={() => copyToClipboard(comment)}
          variant="secondary"
          size="xsmall"
          className="h-10 w-10 shrink-0 p-0 disabled:text-gr-400"
          disabled={!comment}
        >
          <CopyIcon />
        </Button>
      </div>
      <div className="shrink-0">
        <SubmitButton handleRegister={handleRegister} isLoading={isLoading} comment={comment} />
      </div>
    </div>
  );
};

export default AnswerController;
